import { STRING_INSTRUMENT_CODES, KEYBOARD_INSTRUMENT_CODES } from 'const'

export const isStringInstrument = (code: string) => {
  return STRING_INSTRUMENT_CODES.includes(code)
}

export const isKeyboardInstrument = (code: string) => {
  return KEYBOARD_INSTRUMENT_CODES.includes(code)
}
